export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/business_proposal.d6a4d6c.svg";